import { render, staticRenderFns } from "./ScheduleForm.vue?vue&type=template&id=8228233c"
import script from "./ScheduleForm.vue?vue&type=script&lang=js"
export * from "./ScheduleForm.vue?vue&type=script&lang=js"
import style0 from "./ScheduleForm.vue?vue&type=style&index=0&id=8228233c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports